import { createSlice } from "@reduxjs/toolkit";

const messages = createSlice({
    name: "messages",
    initialState: {
        partRequestMessages: [],
        partRequestMessagesLoaded: false,
        activeRequestsMessages: [],
        activeRequestsMessagesLoaded: false,
        otherMessages: [],
        otherMessagesLoaded: false,
        count: 0,
        otherMessagesCount: 0,
    },
    reducers: {
        getPartRequestMessages(state, _action) {
            return { ...state, partRequestMessagesLoaded: false }
        },
        setPartRequestMessages(state, action) {
            const requestData = Object.values(action.payload);

            return {
                ...state,
                partRequestMessages: requestData[1],
                partRequestMessagesCount: requestData[0],
                partRequestMessagesLoaded: true,
            }
        },
        getActiveRequestsMessages(state, _action) {
            return { ...state, activeRequestsMessagesLoaded: false }
        },
        setActiveRequestsMessages(state, action) {
            const requestData = Object.values(action.payload);
            return {
                ...state,
                activeRequestsMessages: requestData[1],
                count: requestData[0],
                activeRequestsMessagesLoaded: true,
            }
        },
        getOtherMessages(state, _action) {
            return { ...state, otherMessagesLoaded: false }
        },
        setOtherMessages(state, action) {
            const requestData = Object.values(action.payload);
            return {
                ...state,
                otherMessages: requestData[1],
                otherMessagesCount: requestData[0],
                otherMessagesLoaded: true,
            }
        },
        sendMessage(state, _action) {
            return { ...state, partRequestMessagesLoaded: false }
        },
    },
});

export const {
    getPartRequestMessages,
    setPartRequestMessages,
    getActiveRequestsMessages,
    setActiveRequestsMessages,
    getOtherMessages,
    setOtherMessages,
    sendMessage
} = messages.actions;

export default messages.reducer;
